import {FunctionComponent, HTMLAttributes} from 'react';
import {useTranslation} from 'react-i18next';
import IconClose from '@/assets/images/icon-close.svg?react';
import {TrackedButton} from '@/components/tracked-atoms/tracked-button';
import {TrackingClickPrefix} from '@/services/analytics/analytics-types';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';

type ElementProps = HTMLAttributes<HTMLDivElement> & {
  title: string;
  onClose: () => void;
};

const DialogHeader: FunctionComponent<ElementProps> = ({title, onClose, ...props}) => {
  const {t} = useTranslation();

  return (
    <header className="flex w-full items-center justify-between gap-10" {...props}>
      <div className="text-2xl font-semibold text-violet">{title}</div>

      <TrackedButton
        data-testid="dialog-close-button"
        onClick={onClose}
        aria-label={t('components.dialog.header.close.accessibility-button')}
        trackingKey={WEB_CLICK_TRACKING_KEY.CLOSE_DIALOG}
        trackingAs={TrackingClickPrefix.CONTENT}
      >
        <IconClose className="size-6 fill-violet p-0.5 transition-all hover:fill-violet/60" />
      </TrackedButton>
    </header>
  );
};

export default DialogHeader;
